import React, { useMemo } from 'react';
import { OnOffSwitch } from '../ui';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { ROLE, getLocalMemberRole } from '../members';
import { updateRoomPolicy } from '../settings';
import { SmallRaiseHandToggleStyled } from '../../raise-hand/SmallRaiseHandToggle';
export const ChatLock = React.memo(() => {
    const dispatch = useDispatch();
    const notification_option = useSelector((state) => state['features/base/settings'].policy.notification_option);
    // @ts-ignore
    const isChatLock = useMemo(() => !notification_option.enable_chat_view, [notification_option.enable_chat_view]);
    const local_role = useSelector((state) => getLocalMemberRole(state));
    const lockPermission = useMemo(() => {
        if (local_role && ROLE.PARTICIPANT === local_role)
            return false;
        return true;
    }, [local_role]);
    // 방 환경 설정 함수
    const handlerUpdatePolicy = () => {
        if (lockPermission) {
            dispatch(
            // @ts-ignore
            updateRoomPolicy(
            // @ts-ignore
            { notification_option: { ...notification_option, enable_chat_view: isChatLock } }, false));
        }
    };
    const label = useMemo(() => (!isChatLock ? 'ON' : 'OFF'), [isChatLock]);
    return (React.createElement(SmallRaiseHandToggleStyled, null,
        React.createElement(OnOffSwitch, { label: label, isShow: !isChatLock, handlerClick: handlerUpdatePolicy })));
});
